import { connect } from "react-redux";

import CitiesComparisonChart from "../../components/visualizations/cities_comparison_chart";
import { onExportDefault } from "../../actions/slide_decks";

const mapStateToProps = (state) => {
  const ld = state.main.loading.loadedData;
  if (!(ld.mainChart)) { return {}; }

  const dataAndOptions = ld.mainChart;
  const title = `Selected cities ${ld.minYear}-${ld.maxYear} tariff comparison`;
  const showExportButton = !state.main.slideDecks.slideDeckBeingSaved;

  return { dataAndOptions, title, showExportButton };
};

const mapDispatchToProps = dispatch => ({
  exportChart: onExportDefault(dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CitiesComparisonChart);
